exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-app-main[data-v-5610a9ba] {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-pack: center;\n\t\t    -ms-flex-pack: center;\n\t\t        justify-content: center;\n\t\t-webkit-box-align: center;\n\t\t    -ms-flex-align: center;\n\t\t        align-items: center;\n\t\tposition: relative;\n\t\tmin-height: calc(100% - 82px);\n\t\tmargin: 16px;\n\t\tbackground: white;\n\t\tfont-size: 18px;\n}\n.blue[data-v-5610a9ba] {\n\tcolor: #3c7ef6;\n}\n\n", ""]);

// exports
